import * as React from 'react'
import * as Container from "../../container/container";

const Video = (key) => {
    return (
        <Container.Part background="beige" id="trailer" key={key}>
            <Container.Row>
                <div className="col-12">
                    <div className="inner-container">
                        <h2>Ein Zeitzeugengespräch über die Proteste gegen die Eingemeindung in Ermershausen.</h2>
                        <figure className="video">
                            <div className="yt-container yt-enabled">
                                <Container.Video
                                    url={"/videos/Filmmaterial/012_Ermershausen/211011_Ermershausen.mp4"}
                                    poster={"/images/Videowallpaper/ermershausen.jpg"}/>
                            </div>
                        </figure>
                    </div>
                </div>
            </Container.Row>
        </Container.Part>
    )
}

export default Video
